import { useState } from 'react';

import PropTypes from 'prop-types';

import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { FormattedMessage, useIntl } from '@zenbusiness/application-commons-intl';
import Text from '@zenbusiness/zui/Text';

import { AiSlideIn } from '#client/components/AiSlideIn';
import { useProductLandingClickstreamProps } from '#client/pages/ProductLanding/hooks/useProductLandingClickstreamProps';

import { useBuyBoxContext } from './BuyBoxContext';
import * as Styled from './VeloBanner.styles';

const VeloBanner = ({ prompt, message, queryType }) => {
  const { formatMessage } = useIntl();
  const { serviceCode, veloBanner } = useBuyBoxContext();
  const { businessEntity } = useBusinessEntity();
  const [isAiOpen, setIsAiOpen] = useState(false);
  const personalizationClickstreamProps = useProductLandingClickstreamProps();

  const buttonMessageId = 'dashboard.carousel.card.askVelo.button';
  const promptSlug = veloBanner?.prompt || prompt;
  const handleOpen = () => setIsAiOpen(true);
  const handleClose = () => setIsAiOpen(false);

  return (
    <>
      <Styled.StyledVeloBanner>
        <Text size="sm" weight="medium" color="primary" flex="2">
          <FormattedMessage id={message} />
        </Text>
        <Styled.ButtonWrapper>
          <Styled.VeloButton aria-label="velo-button" onClick={handleOpen}>
            <FormattedMessage id={buttonMessageId} />
          </Styled.VeloButton>
        </Styled.ButtonWrapper>
      </Styled.StyledVeloBanner>

      {isAiOpen && (
        <AiSlideIn
          key={promptSlug}
          aiSlideInOpen={isAiOpen}
          closeHandler={handleClose}
          title={formatMessage({ id: 'productPage.common.buyBox.veloBanner.slideOut.title' })}
          promptSlug={promptSlug}
          queryType={queryType || veloBanner?.queryType}
          fillData={{
            state: businessEntity?.domesticJurisdiction,
          }}
          eventingProperties={{
            ...personalizationClickstreamProps,
            elementName: 'product_buybox_velo_banner',
            elementText: formatMessage({ id: buttonMessageId }),
            elementValue: serviceCode || 'unknown',
            aiProjectName: 'Product Landing',
          }}
          errorMessage={formatMessage({ id: 'dashboard.orderTracker.errorGeneric' })}
          footer={formatMessage({ id: 'dashboard.orderTracker.footer' })}
        />
      )}
    </>
  );
};

VeloBanner.propTypes = {
  prompt: PropTypes.string.isRequired,
  message: PropTypes.string,
  queryType: PropTypes.string,
};

export default VeloBanner;
